import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class FaqSection extends HTMLElement {
  constructor() {
    super();
		this._onItemClick = this.updateActiveContent.bind(this);
		this._onCategoryClick = this.updateActiveCategory.bind(this);
		if (this.dataset.parentId) {
			this.mergeComponent(this.dataset.parentId);
		} else {
			this.registerEvents();
	}
  }

	registerEvents = () => {
		this.querySelectorAll('.faq-item:has(+ .faq-content)').forEach(element => {
        element.addEventListener('click', this._onItemClick);
    });
    this.querySelectorAll('.faq-item:not(:has(+ .faq-content)):not([data-link])').forEach(element => {
        element.addEventListener('click', this._onCategoryClick);
    });
	}

  isMobile = () => {
    const mobileMediaQuery = window.matchMedia("(max-width: 749px)");
    return mobileMediaQuery.matches;
  }

  updateActiveContent = (event) => {
    event.preventDefault();
    let target = event.currentTarget.dataset.target;
    if (!this.isMobile()) {
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
        this.querySelectorAll('.faq-content.active')?.forEach(element => {
            element?.classList?.remove('active');
        });
        this.querySelectorAll('.faq-item:has(+ .faq-content).active')?.forEach(element => {
            element?.classList?.remove('active');
        });
    }
    event.currentTarget?.classList?.toggle('active');
    this.querySelectorAll(`.faq__maincontent [data-id='${target}']`)?.forEach(element => {
        element.classList?.toggle('active');
    });
  };

  updateActiveCategory = (event) => {
			event.preventDefault();
			event.currentTarget?.classList?.toggle('active');
  };

mergeComponent = async (id) => {
    const parentComponent = document.querySelector(`#${id}`);

    await this.querySelectorAll(".faq__sidemenu > .shopify-block > .faq-item").forEach(element => {
        let targetComponent = parentComponent.querySelector(`.faq__sidemenu .faq-item[data-id="${element.dataset.id}"]`);
				let targetContentComponent = parentComponent.querySelector(`.faq__maincontent`);
        if (targetComponent) {
            element.parentElement.querySelectorAll(":scope > .shopify-block > .faq-item").forEach(e => {
                let targetComponent = parentComponent.querySelector(`.faq__sidemenu .faq-item[data-id="${e.dataset.id}"]`);
                if (targetComponent) {
                    e.parentElement.querySelectorAll(':scope > .shopify-block').forEach(e => {
                        targetContentComponent.insertAdjacentElement('beforeend', this.querySelector(`.faq__maincontent .faq-content[data-id="${e.querySelector(":scope > a").dataset.target}"]`));
                        targetComponent.parentElement.insertAdjacentElement('beforeend', e);
                    });
                } else {
									parentComponent.querySelector(`.faq__sidemenu .faq-item[data-id="${element.dataset.id}"]`).parentElement.insertAdjacentElement("beforeend", e.parentElement);
									if (this.querySelector(`.faq__maincontent .faq-content[data-id="${e.dataset.target}"]`)) {
										targetContentComponent.insertAdjacentElement('beforeend', this.querySelector(`.faq__maincontent .faq-content[data-id="${e.dataset.target}"]`));
									}
								}
            });
        } else {
            parentComponent.querySelector('.faq__sidemenu').appendChild(element.parentElement);
        }

    });

    parentComponent.querySelector('faq-section').registerEvents();

    this.remove();

    // merge lv2
    // this.querySelectorAll(".faq__sidemenu > .shopify-block > .shopify-block > .faq-item").forEach(element => {
    //     let targetComponent = parentComponent.querySelector(`.faq__sidemenu .faq-item[data-id="${element.dataset.id}"]`);
    //     if (targetComponent) {
    //         element.parentElement.querySelectorAll(':scope> .shopify-block').forEach(e => {
    //             targetComponent.parentElement.appendChild(e);
    //         });
    //     }
    // });
  }
}

if (!customElements.get('faq-section')) {
  customElements.define('faq-section', FaqSection);
}
